const VoiceManager = (function () {
    let voices = [];
    let voicesLoaded = false;

    async function loadVoices() {
        return new Promise((resolve, reject) => {
            voices = speechSynthesis.getVoices();
            if (voices.length !== 0) {
                voicesLoaded = true;
                resolve(voices);
            } else {
                speechSynthesis.onvoiceschanged = () => {
                    voices = speechSynthesis.getVoices();
                    voicesLoaded = true;
                    resolve(voices);
                };

                setTimeout(() => {
                    if (!voicesLoaded) {
                        reject('Voices not loaded.');
                    }
                }, 5000);
            }
        });
    }

    function getVoices() {
        return voices;
    }

    return {
        loadVoices,
        getVoices,
        isLoaded: () => voicesLoaded
    };
})();


document.addEventListener("DOMContentLoaded", () => {
    speechSynthesis.getVoices();
});

function devtricker_speak_clearAllHighlights() {
    const highlightedElements = document.querySelectorAll('.devtricker-highlight');
    highlightedElements.forEach(element => {
        element.classList.remove('devtricker-highlight');
    });
}

function devtricker_getPreferredLocale(languageCode) {
    const preferredLocale = navigator.languages.find(lang => lang.startsWith(languageCode));

    return preferredLocale || languageCode;
}

function devtricker_getBestVoice(voices, text) {
    const naturalKeywords = [
        'google', 'natural', 'wavenet', 'neural',
        'premium', 'enhanced', 'high quality', 'luciana', 'mark', 'samantha'
    ];

    const francLangCode = franc.franc(text);
    const lang = devtricker_tryGetIso6391From6392(francLangCode);
    const preferredLang = devtricker_getPreferredLocale(lang);

    function normalizeLangCode(langCode) {
        const parts = langCode.replace('_', '-').split('-');
        let primary = parts[0].toLowerCase();
        let region = parts[1] ? parts[1].toUpperCase() : null;
        if (primary.length === 3) {
            primary = devtricker_tryGetIso6391From6392(primary);
        }
        return region ? `${primary}-${region}` : primary;
    }

    function languageMatches(voiceLangCode, targetLangCode, ignoreRegion = false) {
        const voiceLang = normalizeLangCode(voiceLangCode);
        const targetLang = normalizeLangCode(targetLangCode);

        if (ignoreRegion) {
            return voiceLang.split('-')[0] === targetLang.split('-')[0];
        } else {
            return voiceLang === targetLang;
        }
    }

    function isNaturalVoice(voice) {
        return naturalKeywords.some(keyword =>
            voice.name.toLowerCase().includes(keyword)
        );
    }

    function getMatchingVoices(voices, targetLang, ignoreRegion) {
        return voices
            .filter(voice => languageMatches(voice.lang, targetLang, ignoreRegion))
            .sort((a, b) => {
                const aIsNatural = isNaturalVoice(a) ? 1 : 0;
                const bIsNatural = isNaturalVoice(b) ? 1 : 0;
                if (aIsNatural !== bIsNatural) {
                    return bIsNatural - aIsNatural;
                }

                const aKeywordIndex = naturalKeywords.findIndex(keyword =>
                    a.name.toLowerCase().includes(keyword)
                );
                const bKeywordIndex = naturalKeywords.findIndex(keyword =>
                    b.name.toLowerCase().includes(keyword)
                );

                if (aKeywordIndex !== -1 && bKeywordIndex !== -1) {
                    return aKeywordIndex - bKeywordIndex;
                }

                if (aKeywordIndex !== -1) return -1;
                if (bKeywordIndex !== -1) return 1;

                return 0;
            });
    }

    let matchingVoices = getMatchingVoices(voices, preferredLang, false);
    if (matchingVoices.length > 0) {
        return matchingVoices[0];
    }

    matchingVoices = getMatchingVoices(voices, preferredLang, true);
    if (matchingVoices.length > 0) {
        return matchingVoices[0];
    }

    return null;
}